import { render, staticRenderFns } from "./UpdateTaskImages.vue?vue&type=template&id=59f98387"
import script from "./UpdateTaskImages.vue?vue&type=script&lang=js"
export * from "./UpdateTaskImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports